










import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<MiElementPanelItem>({})
export default class MiElementPanelItem extends Vue {
  @Prop({ default: false })
  protected collapse!: boolean;

  @Prop({ default: false })
  protected borderless!: boolean;

  @Prop({ default: 4 })
  protected elevation!: number;
}
